import axios from "axios";
import toast from "react-hot-toast";
import { config } from "../../Utils/helpers";

const user = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : "";

const token = user ? user.data.token : "";

axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GetAdminList = (adminData, showLoader = true) => {
  return async (dispatch) => {
    try {
      if (showLoader) {
        dispatch({ type: "ADMIN_LIST_REQUEST" });
      }

      const { data } = await axios.post(
        `${BASE_URL}/admin/list`,
        adminData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "ADMIN_LIST_SUCCESS",
          payload: data,
        });
      } else {
        dispatch({
          type: "ADMIN_LIST_FAIL",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "ADMIN_LIST_FAIL",
        payload: error?.response?.data?.message || "Something went wrong",
      });
    }
  };
};


export const addAdmin = (adminData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_ADMIN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/admin/signup`,
        adminData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_ADMIN_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_ADMIN_FAIL", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_ADMIN_FAIL",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    }
  };
};

export const editAdmin = (editData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "EDIT_ADMIN_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/admin/update-profile`,
        editData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_ADMIN_SUCCESS", payload: data });
        toast.success("Edit Successful!!");
        return data;
      } else {
        dispatch({ type: "EDIT_ADMIN_FAIL", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_ADMIN_FAIL",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
      return error?.response?.data?.message;
    }
  };
};

export const viewAdmin = (editData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_ADMIN_REQUEST" });

      const { data } = await axios.get(
        `${BASE_URL}/admin/profile/${editData}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_ADMIN_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_ADMIN_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_ADMIN_FAIL",
        payload: error?.response?.data?.message,
      });
    }
  };
};

export const clearErrors = () => async (dispatch) => {
  dispatch({ type: "CLEAR_ERRORS" });
};


export const addAccessCode = (accessData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_ACCESS_CODE_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/admin/add-access-code`,
        accessData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_ACCESS_CODE_SUCCESS", payload: data });
        toast.success("Access code added successfully");
        return data;
      } else {
        dispatch({ type: "ADD_ACCESS_CODE_FAIL", payload: data });
        return data;
      }
    } catch (error) {
      const msg = error?.response?.data?.message;
      dispatch({
        type: "ADD_ACCESS_CODE_FAIL",
        payload: msg,
      });
      toast.error(msg || "Something went wrong");
      return msg;
    }
  };
};

export const GetAccessCodeList = (adminData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ACCESS_CODE_LIST_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/admin/access-code-list`,
        adminData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ACCESS_CODE_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "ACCESS_CODE_LIST_FAIL", payload: data });
      }
    } catch (error) {
      dispatch({ type: "ACCESS_CODE_LIST_FAIL", payload: error.response });
    }
  };
};

export const removeAccessCode = (accessData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "REMOVE_ACCESS_CODE_REQUEST" });

      const { data } = await axios.post(
        `${BASE_URL}/admin/remove-access-code`,
        accessData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_ACCESS_CODE_SUCCESS", payload: data });
        toast.success("Access code removed successfully");
        return data;
      } else {
        dispatch({ type: "REMOVE_ACCESS_CODE_FAIL", payload: data });
        return data;
      }
    } catch (error) {
      const msg = error?.response?.data?.message;
      dispatch({
        type: "REMOVE_ACCESS_CODE_FAIL",
        payload: msg,
      });
      toast.error(msg || "Something went wrong");
      return msg;
    }
  };
};

